import React from "react";
import { useNavigation } from "@react-navigation/native";
import {
  Box,
  MainText,
  MainTitle,
  PressableOpacity,
} from "app/components/common";
import CrossIcon from "app/components/Icons/CrossIcon";
import Theme from "app/constants/Theme";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import ArrowLeft from "app/components/Icons/Arrow/ArrowLeft";

export interface IHeaderScreenProps {
  title: string;
  subtitle?: string;
  callbackOnPress?: () => void;
  onPressSubtitle?: () => void;
}

const HeaderActionScreen = ({
  title,
  subtitle,
  callbackOnPress,
  onPressSubtitle,
}: IHeaderScreenProps) => {
  const navigation = useNavigation();

  const pressedIcon = () => {
    if (!callbackOnPress) {
      navigation.goBack();
    } else {
      callbackOnPress();
    }
  };

  return (
    <Box
      flexDirection="row"
      width="100%"
      alignItems="flex-start"
      marginBottom={isWebDesktop ? "xm" : "xxs"}
    >
      <Box flex={1} flexDirection="row" alignItems="center">
        {!isWebDesktop && (
          <PressableOpacity
            style={{ marginRight: theme.spacing.xs }}
            onPress={pressedIcon}
            hitSlop={Theme.HITSLOP}
          >
            <ArrowLeft color={theme.colors["neutral.900"]} />
          </PressableOpacity>
        )}
        <Box
          maxWidth="90%"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <MainTitle variant="l6-bold">{title}</MainTitle>
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderActionScreen;
